import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ActionStaff, ChangePassword, InitialState, MFANoCache } from "./staffModels";

const initialState: InitialState = {
    selectedStaff: {
        title: "Add New User"
    },
    changePassword: {
        id: "",
        mode: "user",
        currentPassword: "",
        newPassword: "",
        confirmedPassword: ""
    },
    currentStaffMFA: {
        mfa: 0,
        no_cache: Math.random().toString()
    }
}

const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers:{
        setSelectedStaff: (state, action: PayloadAction<ActionStaff>) => {
            state.selectedStaff = action.payload
        }, 
        setChangePassword: (state, action: PayloadAction<ChangePassword>) => {
            state.changePassword = action.payload
        },
        setChangeStaffMFA: (state, action: PayloadAction<MFANoCache>) => {
            state.currentStaffMFA = action.payload
        },
    }
})

export default staffSlice.reducer
export const {
    setSelectedStaff,
    setChangePassword,
    setChangeStaffMFA
} = staffSlice.actions

